const defaultLength = 50;
export const truncateText = (text: string, length = defaultLength) =>
  text.length < length ? text : `${text.substring(0, length)}...`
